import { useCallback, useState } from 'react';
import { FlatList, Pressable, RefreshControl, Text, View } from 'react-native';
import { useFocusEffect, useRouter } from 'expo-router';
import { useAuth } from '../context/AuthContext';
import { myShops } from '../api/shops';
import { Shop } from '../types';
import { Button, Card, EmptyState, ScreenContainer } from '../components/ui';
import { PlatformQuestsSection } from '../components/PlatformQuestsSection';
import { colors, fonts } from '../theme';

export default function OwnerHomeScreen() {
  const { token, user } = useAuth();
  const isIndividual = user?.posterKind === 'INDIVIDUAL';
  const router = useRouter();
  const [shops, setShops] = useState<Shop[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      setShops(await myShops(token));
    } finally {
      setLoading(false);
    }
  }, [token]);

  useFocusEffect(
    useCallback(() => {
      load();
    }, [load]),
  );

  return (
    <ScreenContainer safeTop safeBottom>
      <FlatList
        data={shops}
        keyExtractor={(item) => item.id}
        refreshControl={<RefreshControl refreshing={loading} onRefresh={load} />}
        ListHeaderComponent={
          <>
            <PlatformQuestsSection />
            <View style={{ marginBottom: 12 }}>
              <Button
                title={isIndividual ? '+ Thêm địa điểm mới' : '+ Tạo shop mới'}
                onPress={() => router.push('/create-shop')}
              />
            </View>
          </>
        }
        ListEmptyComponent={!loading ? <EmptyState text="Bạn chưa có shop nào" /> : null}
        renderItem={({ item }) => (
          <Pressable onPress={() => router.push(`/shop/${item.id}`)}>
            <Card>
              <Text style={{ fontSize: 16, fontFamily: fonts.bold, color: colors.text }}>
                {item.name}
              </Text>
              <Text style={{ color: colors.textMuted, marginTop: 2 }}>{item.address}</Text>
            </Card>
          </Pressable>
        )}
      />
    </ScreenContainer>
  );
}
